import { inject, Injectable } from '@angular/core';
import { SharedLanguageService } from '@language';
import { Inheritance } from '../../../core/field-definitions/entities/field-definition.entity';
import { FieldInheritance } from '../../../core/records/entities/record-inheritance.class';
import { LabelIcon } from '../../../form-controls/components/_core/form-label/label-icon.entity';

@Injectable({ providedIn: 'root' })
export class FieldIconHelper {
    private readonly translateService: SharedLanguageService = inject(SharedLanguageService);

    public setInheritanceIcon(icons: LabelIcon[], fieldInheritance: FieldInheritance): LabelIcon[] {
        if (fieldInheritance.Inheritance !== Inheritance.Propagation) {
            // Only indicate for Propagation inheritance
            return icons;
        }

        const messages = [this.translateService.instant('profile-form.inheritance.propagation')];

        if (fieldInheritance.Broken) {
            messages.push(this.translateService.instant('profile-form.inheritance.broken'));
        } else {
            messages.push(this.translateService.instant('profile-form.inheritance.intact'));
        }

        const newLabelIcon: LabelIcon = {
            icon: fieldInheritance.Broken ? 'unlink' : 'link',
            tooltip: messages.join('\n'),
            priority: 0
        };

        const existingLabelIconIndex: number = icons.findIndex(icon => ['unlink', 'link'].includes(icon.icon));
        if (existingLabelIconIndex !== -1) {
            icons[existingLabelIconIndex] = newLabelIcon;
            return icons;
        }

        icons.push(newLabelIcon);
        return this.sortIcons(icons);
    }

    public setAiIcon(icons: LabelIcon[]): LabelIcon[] {
        const newLabelIcon: LabelIcon = {
            icon: 'magic',
            tooltip: this.translateService.instant('profile-form.ai-field'),
            priority: 1
        };

        // If the icon already exists, update it in place
        const existingLabelIconIndex: number = icons.findIndex(icon => 'magic' === icon.icon);
        if (existingLabelIconIndex !== -1) {
            icons[existingLabelIconIndex] = newLabelIcon;
            return icons;
        }

        // else add it to the list and sort it again, according to priorities
        icons.push(newLabelIcon);
        return this.sortIcons(icons);
    }

    private sortIcons(icons: LabelIcon[]): LabelIcon[] {
        return icons.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));
    }
}
